 // ✅ components/BulkControls.jsx
import React from "react";

const BulkControls = ({ fetchAllOrderIds, bulkPushToZippee, selectedOrders, currentPage }) => {
  return (
    <div className="my-3">
      <button className="btn btn-warning btn-lg mr-3" onClick={() => fetchAllOrderIds(currentPage)}>
        Select All Orders (All Pages)
      </button>
      <button
        className="btn btn-success btn-lg"
        onClick={bulkPushToZippee}
        disabled={selectedOrders.size === 0}
      >
        🚀 Push Selected Orders to Zippee ({selectedOrders.size})
      </button>
    </div>
  );
};

export default BulkControls;
